export default __webpack_public_path__ + "static/media/Heart_outline_white.6c33cfd2.svg";